/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { fetchHealthUsingGet } from '../fn/health-api/fetch-health-using-get';
import { FetchHealthUsingGet$Params } from '../fn/health-api/fetch-health-using-get';


/**
 * Health API
 */
@Injectable({ providedIn: 'root' })
export class HealthApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fetchHealthUsingGet()` */
  static readonly FetchHealthUsingGetPath = '/v2/health';

  /**
   * fetchHealth.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fetchHealthUsingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchHealthUsingGet$Response(params?: FetchHealthUsingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return fetchHealthUsingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * fetchHealth.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fetchHealthUsingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchHealthUsingGet(params?: FetchHealthUsingGet$Params, context?: HttpContext): Observable<{
}> {
    return this.fetchHealthUsingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

}
